export default __webpack_public_path__ + "static/media/poster_b.ad63eaff.png";